import React, { FC, useEffect } from 'react';
import 'plyr/dist/plyr.css'
import FetchAudio from "../components/UI/FetchAudio";
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store';

const Homepage: FC = () => {
  const { error } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {

  }, [error, dispatch]);

  return(
        <FetchAudio />
  );
};

export default Homepage;
